import React, { useEffect, useState } from "react";
import { ConfigurationPanel } from "../..";
import { PolicyList } from "./policyList";
import { PolicyDetail } from "./policyDetail";
import { createPolicies, updatePolicies, getPolicies, deletePolicies } from "../../../../../../api/policies";
import { BiPlus } from "react-icons/bi";

export const Policies = () => {
  const [policyDetails, setPolicyDetails] = useState(null);
  const [policiesData, setPoliciesData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const query = async () => {
    const response = await getPolicies();
    if (response && !response.error) {
      setPoliciesData(response.data);
      console.log("POLICIES", response.data);
    }
  };

  useEffect(() => {
    query();
  }, []);

  const deletePolicy = async (policyId) => {
    try {
      const response = await deletePolicies(policyId);
      if (response && !response.error) {
        console.log("Policy deleted:", response);
        setPolicyDetails(null);
        query();
      }
    } catch (error) {
      console.error("Error deleting policy:", error);
    }
  };

  const handlePolicy = (selectedPolicy) => {
    const existingPolicy = policiesData.find((policy) => policy.legalPoliciesId === selectedPolicy.legalPoliciesId);

    if (existingPolicy) {
      setPolicyDetails(existingPolicy);
      setIsEditing(true);
    } else {
      setPolicyDetails(selectedPolicy);
      setIsEditing(false);
    }
  };

  const newPolicy = () => {
    setPolicyDetails({});
    setIsEditing(false);
  };

  const createPolicy = async (method) => {
    if (method === "cancel") {
      setPolicyDetails(null);
    } else {
      // Obtener valores de los inputs de título y texto
      const title = document.getElementById("polityTitleInput").value;
      const text = document.getElementById("polityTextEditor").innerHTML;
      //const type = document.getElementById("polityType").value;

      const policyData = {
        type: "legalNotice",
        title,
        text,
        /*legalPoliciesId: policyDetails.legalPoliciesId,
      corporationId: policyDetails.corporationId,*/
      };

      console.log(policyData);

      try {
        const response = await createPolicies(policyData);
        if (response && !response.error) {
          console.log("Policy created:", response);
          setPolicyDetails(null);
          query();
        }
      } catch (error) {
        console.error("Error handling policy:", error);
      }
    }
  };

  //Save or delete
  const updatePolicy = async (method) => {
    console.log("updatePolicy ==========> ", method);
    if (!policyDetails) return;

    try {
      if (method === "save") {
        // Obtener valores de los inputs de título y texto
        const title = document.getElementById("polityTitleInput").value;
        const text = document.getElementById("polityTextEditor").innerHTML;

        // Validar que el título no esté vacío y que el texto no esté solo con "<br>"
        /*if (!title.trim() || text.trim() === "<br>") {
      alert("Por favor, completa todos los campos antes de guardar.");
      return; // Detener ejecución si falta algún campo
    }*/

        const policyData = {
          type: policyDetails.type,
          title,
          text,
          /*legalPoliciesId: policyDetails.legalPoliciesId,
      corporationId: policyDetails.corporationId,*/
        };
        const response = await updatePolicies(policyDetails.legalPoliciesId, policyData);
        if (response && !response.error) {
          console.log("Policy updated:", response);
          setPolicyDetails(null);
          query();
        }
      } else if (method === "cancel") {
        setPolicyDetails(null);
      } else {
        deletePolicy(policyDetails.legalPoliciesId);
      }
    } catch (error) {
      console.error("Error handling policy:", error);
    }
  };

  return (
    <>
      {policyDetails === null ? (
        <ConfigurationPanel
          title="Políticas escritas"
          content={<PolicyList policies={policiesData} handlePolicy={handlePolicy} />} // Pasamos policiesData a PolicyList
          action={newPolicy}
          textButtonAction={"Nueva política"}
          iconButtonAction={<BiPlus />}
        />
      ) : (
        <ConfigurationPanel
          title={policyDetails.title || ""}
          content={<PolicyDetail policy={policyDetails} isEditing={isEditing} callback={isEditing ? updatePolicy : createPolicy} />}
          action={null}
          hasButtonSave={false}
        />
      )}
    </>
  );
};
